<template>
  <div class="recommender-buttons">
    <button class="recommender-button" v-for='(recommendation,i) in myRecommendations' :key='i' @click='$emit("click", recommendation)'>
      <div class="recommender-button-description">
        {{recommendation.description}}
      </div>

      <plus-circle class="mx-1"/>

      <!--
      <div>
        <div v-for='component in recommendation.componentTypes' :key='component.type.type' class="flex">
          <div class="pbc-recommender-icon-parent">
            <component :is='component.icon' class="pbc-recommender-type-icon" :size='20'/>
          </div>
          <div class="text-gray-600 mt-1 ml-2 text-xs text-center">{{component.type.text}}</div>
        </div>
      </div>
      -->
    </button>

  </div>
</template>
<script>
import PlusCircle from '@icons/PlusCircle.vue';
import { sample } from 'lodash';
import IconMapping from '@components/iconMapping.js';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
export default {
  props: {
    recommendations: {
      type: Array,
      required: true
    }
  },
  computed: {
    myRecommendations() {
      return this.recommendations.map( ({recommendation}) => {
        const componentTypes = recommendation.components.map( (component) => {
          const type = ComponentsDb.types[component.type];
          const icon = IconMapping[type.type];
          return {
            type,
            icon
          }
        });

        const headingType = componentTypes[0].type;
        return {headingType, componentTypes,...recommendation}

      });
    },
  },
  components: {
    PlusCircle
  }
}
</script>
